<template>
<div class="chapter">
<div class="inner_page">
<p class="fm16"><a class="calibre5" id="page_22"></a><img alt="" class="image" src="images/00002.jpeg"/></p>
<p class="fm17">Sandy was reading the undying story of the Prodigal.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0009.vue?a7d072f2